import React, { Component } from 'react';
import AdminCompaniesAddView from '../views/AdminCompaniesAddView';
import { base } from '../../base';

class AdminCompaniesAddContainer extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(values) {
        base.push('companies', {
            data:
                {
                    name: values.name,
                    email: values.email,
                    address: values.address,
                    nit: values.nit,
                    phone: values.phone,
                    status: values.status,
                },
            then(err) {
                if (!err) {
                    // TODO: make something on error
                    // Router.transitionTo('dashboard');
                }
            },
        });
        return this;
    }

    render() {
        return (
            <AdminCompaniesAddView
                handleSubmit={this.handleSubmit}
            />
        );
    }
}
export default AdminCompaniesAddContainer;



// WEBPACK FOOTER //
// ./src/components/containers/AdminCompaniesAddContainer.js